<div class="container-fluid grid">

  <div class="row">
    <button id="add-company-types-btn" class="btn btn-primary btn-sm add-btn" (click)="navigateToAdd()">
      Add new
    </button>
  </div>

  @if (companyTypesLoaded() && industriesLoaded() && !hasError) {
    <!-- List Headings -->
    <div class="row grid-header">
      <div id="company-type-sort-by-id" class="col-sm-2 column-heading no-text-selection" (click)="onColumnHeadingClick('id')">
        <span i18n="Company type id column heading">Company Type ID</span>
        <app-column-sort-icon id="sort-icon-company-type-id" [ordering]="ordering" [fieldName]="'id'"></app-column-sort-icon>
      </div>
      <div id="company-type-sort-by-title" class="col-sm-2 column-heading no-text-selection" (click)="onColumnHeadingClick('title')">
        <span i18n="Company type column heading">Company Types</span>
        <app-column-sort-icon id="sort-icon-company-type-name" [ordering]="ordering" [fieldName]="'title'"></app-column-sort-icon>
      </div>
      <div class="col-sm-3 column-heading no-text-selection">
        <span i18n="Company Type industries column heading">Industries</span>
      </div>
      <div id="company-type-sort-by-date-created" class="col-sm-2 column-heading no-text-selection" (click)="onColumnHeadingClick('created_at')">
        <span i18n="Company Type date created column heading">Date Created</span>
        <app-column-sort-icon id="sort-icon-date-created" [ordering]="ordering" [fieldName]="'created_at'"></app-column-sort-icon>
      </div>
      <div id="company-type-sort-by-date-updated" class="col-sm-2 column-heading no-text-selection" (click)="onColumnHeadingClick('updated_at')">
        <span i18n="Company Type date modified column heading">Date Modified</span>
        <app-column-sort-icon id="sort-icon-date-modified" [ordering]="ordering" [fieldName]="'updated_at'"></app-column-sort-icon>
      </div>
    </div>
    <!-- List Items -->
    @for (companyType of sortedCompanyTypes; track companyType) {
      <rn-company-type-list-item id="company-type-list-item-{{companyType.id}}" (editClicked)="navigateToEdit($event)" [companyType]="companyType" [industryOptions]="industries"></rn-company-type-list-item>
    }
  }
</div>

@if (companyTypesLoaded() && companyTypes.length === 0 && !hasError) {
  <div class="not-found"
    i18n="Message that the user gets when there are no company types to show in the list">There were no company types found.
</div>
}

@if (hasError) {
  <div class="not-found"
    i18n="Message that the user gets when there was an error loading company types">There was an error loading company types.
</div>
}
